import { useCallback, useEffect, useRef } from 'react';

type UseTimeoutReturnType = {
  start: () => void;
  cancel: () => void;
};

const useTimeout = (
  callback: () => any,
  time = 0,
): UseTimeoutReturnType => {
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const start = useCallback(
    (): void => {
      if (!timeout.current) {
        timeout.current = setTimeout(
          (): void => {
            callback();
            timeout.current = null;
          },
          time,
        );
      }
    },
    [callback, time],
  );

  const cancel = useCallback(
    (): void => {
      if (timeout.current) {
        clearTimeout(timeout.current);
        timeout.current = null;
      }
    },
    [],
  );

  useEffect(
    () => (): void => cancel(),
    [cancel],
  );

  return {
    start,
    cancel,
  };
};

export type { UseTimeoutReturnType };
export { useTimeout };
